import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

// import chartsRouter from './modules/charts'
// import nestedRouter from './modules/nested'
// import formRouter from './modules/form'
// import editTableRouter from './modules/editTable'

export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: resolve => require(['@/views/redirect/index'], resolve)
    // () => import('@/views/redirect/index')
  }]
},
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [{
      path: 'index',
      component: resolve => require(['@/views/profile/index'], resolve),
      // () => import('@/views/profile/index'),
      name: 'Profile',
      meta: { title: '个人中心', icon: 'user', noCache: true }
    }]
  },
  {
    path: '/login',
    component: resolve => require(['@/views/login/index'], resolve),
    // () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: resolve => require(['@/views/login/auth-redirect'], resolve),
    // import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: resolve => require(['@/views/error-page/404'], resolve),
    // () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: resolve => require(['@/views/error-page/401'], resolve),
    // () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      component: resolve => require(['@/views/bill/task-report'], resolve),
      // () => import('@/views/bill/task-report'),
      name: 'Dashboard',
      meta: {
        title: '首页',
        icon: 'dashboard',
        affix: true,
        noCache: true
      }
    }]
  },
  {
    path: '/bill',
    component: Layout,
    redirect: '/bill/partnerBudgetTask',
    meta: {
      title: '项目管理',
      icon: 'guide',
      noCache: true
    },
    hidden: true,
    children: [
      {
        path: '/person/form',
        component: resolve => require(['@/views/basic/person/form'], resolve),
        name: 'PersonForm',
        meta: {
          title: '员工详情',
          noCache: false
        },
        hidden: true
      },
      {
        path: '/customer/form',
        component: resolve => require(['@/views/basic/customer/form'], resolve),
        name: 'CustomerForm',
        meta: {
          title: '客户表单',
          noCache: false
        },
        hidden: true
      },
      {
        path: '/achievement/form',
        component: resolve => require(['@/views/basic/achievement/form'], resolve),
        name: 'AchievementForm',
        meta: {
          title: '新增绩效模式',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: '/budget-project/form',
        component: resolve => require(['@/views/basic/budget-project/form'], resolve),
        name: 'BudgetProjectForm',
        meta: {
          title: '预算项目表单',
          icon: 'guide',
          noCache: true
        },
        hidden: true
      },
      {
        path: '/project/form',
        component: resolve => require(['@/views/basic/project/form'], resolve),
        name: 'ProjectForm',
        meta: {
          title: '项目表单',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: '/projectPhase/form',
        component: resolve => require(['@/views/basic/projectPhase/form'], resolve),
        name: 'ProjectPhaseForm',
        meta: {
          title: '项目阶段模板新增',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'contract/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/contract/form'], resolve),
        name: 'ContractForm',
        meta: {
          title: '合同表单',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'contract/changeform/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/contract/changeform'], resolve),
        name: 'ContractChangeForm',
        meta: {
          title: '合同变更单',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'monthkpi/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/monthkpi/form'], resolve),
        name: 'MonthKpiForm',
        meta: {
          title: '月度业绩预测',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'delivery/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/delivery/form'], resolve),
        name: 'DeliveryForm',
        meta: {
          title: '立项（交付）表单',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'delivery/changeform/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/delivery/changeform'], resolve),
        name: 'DeliveryChangeForm',
        meta: {
          title: '立项变更表单',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'delivery/superchangeform/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/delivery/superchangeform'], resolve),
        name: 'SuperDeliveryChangeForm',
        meta: {
          title: '立项超级变更表单',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'ResourceUse/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/ResourceUse/form'], resolve),
        name: 'ResourceUseFrom',
        meta: {
          title: '资源借用表单',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'ProjectPlan/newPlan',
        component: resolve => require(['@/views/bill/ProjectPlan/newPlan'], resolve),
        name: 'NewPlanForm',
        meta: {
          title: '项目进度表单',
          icon: 'guide',
          noCache: false,
        },
        hidden: true
      },
      {
        path: 'risk/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/risk/form'], resolve),
        name: 'RiskForm',
        meta: {
          title: '风险金申请表单',
          noCache: false
        },
        hidden: true
      },
    ]
  },
  {
    path: '/presale',
    component: Layout,
    redirect: '/bill/partnerBudgetTask',
    meta: {
      title: '售前管理',
      icon: 'guide',
      noCache: true
    },
    hidden: true,
    children: [
      {
        path: 'partnerBudgetTask/form/:isEdit?/:id?/:billState?',
        component: resolve => require(['@/views/bill/PartnerBudgetTask/form'], resolve),
        name: 'TaskForm',
        meta: {
          title: '预算任务表单',
          noCache: true
        },
        hidden: true
      },
      {
        path: 'followupForm/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/followupForm/form'], resolve),
        // () => import('@/views/bill/followupForm/form'),
        name: 'followupFormForm',
        meta: {
          title: '售前支持申请',
          noCache: true
        },
        hidden: true
      },
      {
        path: 'counselor/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/counselor/form'], resolve),
        // () => import('@/views/bill/counselor/form'),
        name: 'counselorForm',
        meta: {
          title: '售前支持确认详情',
          noCache: true
        },
        hidden: true
      },
      {
        path: 'applicationForm/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/applicationForm/form'], resolve),
        // () => import('@/views/bill/applicationForm/form'),
        name: 'applicationFormForm',
        meta: {
          title: '技术支持申请详情',
          noCache: true
        },
        hidden: true
      },
      {
        path: 'summary/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/summary/form'], resolve),
        // () => import('@/views/bill/summary/form'),
        name: 'summaryForm',
        meta: {
          title: '技术支持确认详情',
          noCache: true
        },
        hidden: true
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/bill/partnerBudgetTask',
    meta: {
      title: '款项',
      icon: 'guide',
      noCache: true
    },
    hidden: true,
    children: [
      // {
      //   path: 'receivable',
      //   component: () => import('@/views/bill/receivable'),
      //   name: 'Receivable',
      //   meta: {
      //     title: '应收单',
      //     icon: 'guide',
      //     noCache: true
      //   },
      // },
      {
        path: 'receivable/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/receivable/form'], resolve),
        // () => import('@/views/bill/receivable/form'),
        name: 'ReceivableForm',
        meta: {
          title: '应收单详情',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'invoice',
        component: resolve => require(['@/views/bill/invoice'], resolve),
        // () => import('@/views/bill/invoice'),
        name: 'Invoice',
        meta: {
          title: '开票申请',
          icon: 'guide',
          noCache: true
        },
      },
      {
        path: 'invoice/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/invoice/form'], resolve),
        // () => import('@/views/bill/invoice/form'),
        name: 'InvoiceForm',
        meta: {
          title: '新增开票申请',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      {
        path: 'invoice/newform/:contractId?/:arId?',
        component: resolve => require(['@/views/bill/invoice/inform'], resolve),
        // () => import('@/views/bill/invoice/form'),
        name: 'InvoiceNewForm',
        meta: {
          title: '新增开票申请',
          icon: 'guide',
          noCache: true
        },
        hidden: true
      },
      {
        path: 'receipt',
        component: resolve => require(['@/views/bill/receipt'], resolve),
        // () => import('@/views/bill/receipt'),
        name: 'Receipt',
        meta: {
          title: '收款单',
          icon: 'guide',
          noCache: true
        },
      },
      {
        path: 'receipt/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/receipt/form'], resolve),
        // () => import('@/views/bill/receipt/form'),
        name: 'ReceiptForm',
        meta: {
          title: '收款单新增',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
      // 报销
      {
        path: 'reimburse',
        component: resolve => require(['@/views/bill/reimburse'], resolve),
        // () => import('@/views/bill/reimburse'),
        name: 'Reimburse',
        meta: {
          title: '报销',
          icon: 'guide',
          noCache: true
        },
      },
      {
        path: 'reimburse/form/:isEdit?/:id?',
        component: resolve => require(['@/views/bill/reimburse/form'], resolve),
        // () => import('@/views/bill/reimburse/form'),
        name: 'ReimburseForm',
        meta: {
          title: '报销详情',
          icon: 'guide',
          noCache: false
        },
        hidden: true
      },
    ]
  },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // chartsRouter,
  // nestedRouter,
  // formRouter,
  // editTableRouter,
  {
    path: '/icon',
    component: Layout,
    children: [{
      path: 'index',
      component: resolve => require(['@/views/icons/index'], resolve),
      // () => import('@/views/icons/index'),
      name: 'Icons',
      meta: {
        title: '图标',
        icon: 'icon',
        noCache: true
      }
    }]
  },
  {
    path: '/theme',
    component: Layout,
    children: [{
      path: 'index',
      component: resolve => require(['@/views/theme/index'], resolve),
      // () => import('@/views/theme/index'),
      name: 'Theme',
      meta: {
        title: 'Theme',
        icon: 'theme'
      }
    }]
  },
  {
    path: 'external-link',
    component: Layout,
    children: [{
      path: 'http://shxrtech.com',
      meta: {
        title: 'External Link',
        icon: 'link'
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
